<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-80">
            <div class="media">
              <img src="/static/img/test@2x.png"/>
              <div class="media-body">
                <h1>{{examInfo.title}}</h1>
                <div>
                  <span class="gray">유형</span> {{examInfo.exam_type_name}}  ·  <span class="gray">문제수 </span> <span class="number">{{examInfo.quiz_cnt}}</span>  ·  <span class="gray">공개 여부</span>
                  {{examInfo.stat_name}}  ·
                  <span class="gray">카테고리</span> {{examInfo.cate_path}}
                </div>
              </div>
            </div>
          </div>
          <div class="p-2 ml-auto button-group">
            <button type="button" class="btn btn-info" @click="handleCommand('download')" v-if="examInfo.download_url_pdf">시험지</button>
            <button type="button" class="btn btn-secondary" @click="handleCommand('download_desc')" v-if="examInfo.download_url_desc_pdf">정답 및 해설</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="media">
          <img src="/static/img/user@3x.png" class="avatar" />
          <div class="media-body">
            <h5>{{userInfo.class_user_name}}</h5>
            <div>
              <span class="gray">클래스</span> {{userInfo.class_name}}  ·
              <span class="gray">점수</span> <span class="number">{{userInfo.exam_score}}</span>  ·
              <span class="gray">백분위점수</span> <span class="number">{{userInfo.exam_score_100}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card second-card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-2">
            <h2>문항 분석</h2>
          </div>
          <div class="p-2">
            <strong><span class="number mint"></span></strong>
          </div>
        </div>
      </div>

      <div v-if="quizData.length > 0" class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition">
        <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
          <template v-for="t in quizSplitCount">
              <thead :key="'th_1_' + t" class="has-gutter">
                <tr :key="'tr_1_' + t" :with="trIdx = (t - 1) * itemCount">
                  <th class="is-center stone-table-cell stone-table-label">문항</th>
                  <th v-for="i in itemCount" :key="'td_1_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell stone-table-label">
                    <span class="number" v-if="quizData[idx]">{{i+trIdx}}</span>
                  </th>
                </tr>
              </thead>
              <tr :key="'tr_2_' + t">
                <th class="is-center stone-table-cell stone-table-label">채점표</th>
                <td v-for="i in itemCount" :key="'td_2_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                  <span v-if="quizData[idx]" :class="getSolutionClassName(quizData[idx].solution_yn)">{{getSolutionName(quizData[idx].solution_yn)}}</span>
                </td>
              </tr>
              <tr :key="'tr_3_' + t">
                <th class="is-center stone-table-cell stone-table-label">정답률</th>
                <td v-for="i in itemCount" :key="'td_3_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                  <span v-if="quizData[idx]" :class="getSolutionRateClassName(quizData[idx].solution_yn)">{{formatterPrecision(quizData[idx].solution_rate)}}</span>
                </td>
              </tr>
              <tr :key="'tr_4_' + t">
                <th class="is-center stone-table-cell stone-table-label">영역</th>
                <td v-for="i in itemCount" :key="'td_4_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                  <span v-if="quizData[idx]" :class="getSolutionRateClassName(quizData[idx].solution_yn)">{{quizData[idx].group_cate_code_name}}</span>
                </td>
              </tr>
          </template>
        </table>
      </div>
    </div>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M050202',
  mixins: [common.mixins],
  data () {
    return {
      examInfo: {
        exam_seq: 0,
        exam_paper_seq: 0,
        exam_paper_title: '',
        cate_path: '',
        cate_code: '',
        curriculum_seq: '',
        curriculum_name: '',
        quiz_cnt: '',
        exam_type: '',
        exam_type_name: '',
        title: '',
        content: '',
        open_dt: '',
        close_dt: '',
        exam_term: '',
        stat_name: '',
        stat: '',
        exam_user_cnt: 0,
        exam_class_cnt: 0,
        use_yn: 'Y',
        file_name_pdf: '',
        download_url_pdf: '',
        file_name_desc_pdf: '',
        download_url_desc_pdf: ''
      },
      userInfo: {
        class_name: '',
        class_user_name: '',
        stat_name: '',
        submit_date: '',
        exam_score: '',
        exam_score_100: ''
      },
      quizData: [],
      quizSplitCount: 0,
      itemCount: 20
    }
  },
  created () {
    const examSeq = this.$route.params.exam_seq
    if (examSeq && examSeq !== 0) {
      this.loadInfo(examSeq)
    } else {
      this.$router.push({name: 'M050101'})
    }
  },
  methods: {
    // 시험 정보 조회
    loadInfo (examSeq) {
      common.axios.get('/grade/note/' + examSeq)
        .then(response => {
          const result = response.data
          // console.log(result)
          Object.keys(this.examInfo).forEach(key => {
            this.examInfo[key] = this.isEmpty(result.exam[key]) ? '' : result.exam[key]
          })

          Object.keys(this.userInfo).forEach(key => {
            this.userInfo[key] = this.isEmpty(result.exam_user[key]) ? '' : result.exam_user[key]
          })

          this.quizData = result.exam_quiz
          let quizCount = 1
          if (this.quizData.length < this.itemCount) {
            this.itemCount = this.quizData.length
          } else {
            quizCount = parseInt(this.quizData.length / this.itemCount, 10)
            if (this.quizData.length % this.itemCount > 0) {
              quizCount++
            }
          }
          this.quizSplitCount = quizCount
        })
    },
    getSolutionName (value) {
      return value === 'Y' ? 'O' : 'X'
    },
    getSolutionClassName (value) {
      return 'font-bold ' + (value === 'Y' ? 'font-green' : 'font-red')
    },
    getSolutionRateClassName (value) {
      return 'number font-bold ' + (value === 'Y' ? '' : 'font-red')
    },
    deleteExam () {
      this.$confirm('해당 오답노트 시험을 삭제하시겠습니까?', '', {
      }).then(() => {
        common.axios.delete('/exam', {data: {exam_seq: this.examInfo.exam_seq}})
          .then(response => {
            if (response.data.status === 1) {
              this.$message('오답노트 시험이 삭제되었습니다.')
              setTimeout(() => {
                this.$router.push({name: 'M050101'})
              }, 1000)
            } else {
              this.$message.warning(response.data.message)
            }
          })
          .catch(() => {
            this.$message.error('삭제 실패하였습니다. 관리자에게 문의하세요')
          })
      }).catch(() => {
      })
    },
    handleCommand (command) {
      if (command === 'download') {
        this.downloadFile(this.examInfo.download_url_pdf)
      } else if (command === 'download_desc') {
        this.downloadFile(this.examInfo.download_url_desc_pdf)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .el-table .warning-row .stone-table-cell {
    background: oldlace !important;
    text-decoration-line: line-through;
  }
  .el-table .success-row .stone-table-cell {
    background: #f0f9eb !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M050202.vue